import { reducerTypes } from './types';
import { IProduct } from '../../interfaces/product';
import { IPageInfo } from '../../interfaces/common';
import { FilterType, SuggestionType } from '../../react-pages/Catalog/types';

export const getHomeProductsAction = (data: IProduct[]) => ({
  type: reducerTypes.GET_HOME_PRODUCTS,
  payload: data,
});

export const getProductsAction = (data: IProduct[]) => ({
  type: reducerTypes.GET_ALL_PRODUCTS,
  payload: data,
});

export const getMoreProductsAction = (data: IProduct[]) => ({
  type: reducerTypes.GET_MORE_PRODUCTS,
  payload: data,
});

export const getFavoritesAction = (data: IProduct[]) => ({
  type: reducerTypes.GET_FAVORITES,
  payload: data,
});

export const getCompareAction = (data: IProduct[]) => ({
  type: reducerTypes.GET_COMPARE,
  payload: data,
});

export const getAlsoLikedProductsAction = (data: IProduct[]) => ({
  type: reducerTypes.GET_ALSO_LIKED_PRODUCTS,
  payload: data,
});

export const getProductAction = (data: IProduct) => ({
  type: reducerTypes.GET_PRODUCT,
  payload: data,
});

export const setSizePageAction = (page: IPageInfo) => ({
  type: reducerTypes.SET_PAGE_INFO,
  payload: page,
});

export const getFiltersAction = (data: FilterType[]) => ({
  type: reducerTypes.GET_FILTERS,
  payload: data,
});

export const getInitialFiltersAction = (data: FilterType[]) => ({
  type: reducerTypes.GET_INITIAL_FILTERS,
  payload: data,
});

export const getSuggestionAction = (data: SuggestionType) => ({
  type: reducerTypes.GET_SUGGESTION,
  payload: data,
});

export const setSortingAction = (sorting: string) => ({
  type: reducerTypes.SET_SORTING,
  payload: sorting,
});

export const setPriceRangeAction = (range: number[]) => ({
  type: reducerTypes.SET_PRICE_RANGE,
  payload: range,
});

export const setSelectedProductsAction = (products: IProduct[]) => ({
  type: reducerTypes.SET_SELECTED_PRODUCTS,
  payload: products,
});

export const setSelectedCollectionTable = (products: IProduct[]) => ({
  type: reducerTypes.SET_SELECTED_COLLECTION_TABLE,
  payload: products,
});
